import {
  Breadcrumbs,
  Button,
  Card,
  Container,
  Icon,
  List,
  Pagination,
  Section,
  Stack,
} from "@storoey/sui";
import { createFileRoute, useRouter } from "@tanstack/solid-router";
import { For } from "solid-js";
import { z } from "zod";
import { backendService } from "../../../backend/backend.service";
import { usePageTitle } from "../../../hooks/usePageTitle";
import { toOffsetLimit } from "../../../utils/to-offset-limit";

export const Route = createFileRoute("/settings/storage/recordings")({
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(8).default(8),
  }),
  loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
  loader: async ({ deps: { page, pageSize } }) => {
    const { offset, limit } = toOffsetLimit(page, pageSize);

    const { data, total } = await backendService.getRecordingsPaged(
      offset,
      limit
    );

    return { page, pageSize, data, total };
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Opptak");
  const loaderData = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const router = useRouter();

  const handleDeleteRecording = async (recordingId: number) => {
    await backendService.deleteRecording(recordingId);
    await router.invalidate();
  };

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <Container>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate({ to: "/" })}>
              Hjem
            </Breadcrumbs.Item>
            <Breadcrumbs.Item onClick={() => navigate({ to: "/settings" })}>
              Innstillinger
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() => navigate({ to: "/settings/storage" })}
            >
              Lagring
            </Breadcrumbs.Item>
            <Breadcrumbs.Item current>Opptak</Breadcrumbs.Item>
          </Breadcrumbs>
        </Container>
      }
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Card.Title>Opptak</Card.Title>
              <Card.Text>List over alle opptak</Card.Text>
            </Card.Content>
            <Card.Actions>
              <List>
                <For each={loaderData().data}>
                  {(recording) => (
                    <List.Item
                      leading={
                        <Button
                          size="small"
                          leftIcon={<Icon>play_arrow</Icon>}
                          variant="ghost"
                          onClick={() => console.log("Icon")}
                        ></Button>
                      }
                      onClick={() => console.log("Item")}
                      trailing={
                        <Button
                          size="small"
                          leftIcon={<Icon>delete</Icon>}
                          color="red"
                          variant="ghost"
                          onClick={() => handleDeleteRecording(recording.id)}
                        ></Button>
                      }
                    >
                      {recording.formName ?? recording.id}
                    </List.Item>
                  )}
                </For>
              </List>
            </Card.Actions>
            <Card.Actions align="center">
              <Pagination
                page={loaderData().page}
                totalPages={Math.ceil(
                  loaderData().total / loaderData().pageSize
                )}
                onPageChange={(page) =>
                  navigate({
                    search: (prev) => ({
                      ...prev,
                      page,
                    }),
                  })
                }
              />
            </Card.Actions>
          </Card>
        </Stack>
      </Container>
    </Section>
  );
}
